import React from 'react';
import PropTypes from 'prop-types';
import Dropzone, { SubmitButton } from 'react-dropzone-uploader';
import 'react-dropzone-uploader/dist/styles.css';
import { API_ENDPOINTS, BASE_URL, buildURL } from '../../utils';
import requestInterceptor from '../../utils/http/requestInterceptor';
import BoxedPreview from './previews/boxedPreview/BoxedPreview';
import SimpleLayout from './layouts/simple/SimpleLayout';
import SimpleInputField from './inputFields/simlpe/SimpleInputField';

const DropzoneUploader = props => {
  const {
    acceptedFiles,
    handleStatusChange,
    handleSubmit,
    queryParams,
    minSizeBytes,
    maxSizeBytes,
    maxFiles,
    LayoutComponent,
    PreviewComponent,
    InputComponent,
    showSubmitButton,
  } = props;

  const getUploadParams = () => {
    const newConfig = requestInterceptor({});

    const formattedURL = buildURL(API_ENDPOINTS.UPLOAD_URL, {}, queryParams);

    return {
      url: `${BASE_URL}${formattedURL}`,
      headers: newConfig.headers,
    };
  };

  // called every time a file's `status` changes
  const statusChangeHandler = (uploadObj, status) => {
    handleStatusChange(uploadObj, status);
  };

  // receives array of files that are done uploading when submit button is clicked
  const submitHandler = (uploadedFilesArray, allFiles) => {
    handleSubmit(uploadedFilesArray);
    allFiles.forEach(f => f.remove());
  };

  return (
    <Dropzone
      accept={acceptedFiles}
      getUploadParams={getUploadParams}
      maxFiles={maxFiles}
      maxSizeBytes={maxSizeBytes}
      minSizeBytes={minSizeBytes}
      onChangeStatus={statusChangeHandler}
      onSubmit={submitHandler}
      LayoutComponent={LayoutComponent}
      PreviewComponent={PreviewComponent}
      InputComponent={InputComponent}
      SubmitButtonComponent={showSubmitButton ? SubmitButton : null}
    />
  );
};

DropzoneUploader.propTypes = {
  acceptedFiles: PropTypes.string,
  handleStatusChange: PropTypes.func,
  handleSubmit: PropTypes.func,
  queryParams: PropTypes.object,
  minSizeBytes: PropTypes.number,
  maxSizeBytes: PropTypes.number,
  maxFiles: PropTypes.number,
  LayoutComponent: PropTypes.func,
  PreviewComponent: PropTypes.func,
  InputComponent: PropTypes.func,
  showSubmitButton: PropTypes.bool,
};

DropzoneUploader.defaultProps = {
  acceptedFiles: 'image/jpeg,image/jpg,image/png,application/pdf,application/msword',
  handleStatusChange: () => {},
  handleSubmit: () => {},
  queryParams: {},
  minSizeBytes: 10240,
  maxSizeBytes: 1000000,
  maxFiles: 3,
  LayoutComponent: SimpleLayout,
  PreviewComponent: BoxedPreview,
  InputComponent: SimpleInputField,
  showSubmitButton: true,
};

export default DropzoneUploader;
